import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  rewardList: [],
  rewardUserList: [],
  rewardUserListAll: [],
  rewardDetail: [],
  rewardItemsList: [],
  loading: false,
  error: undefined,
};

const rewardSlice = createSlice({
  name: "reward",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchRewardList(state, action) {
      state.rewardList = action.payload;
      state.loading = false;
    },
    fetchUserRewardList(state, action) {
      state.rewardUserList = action.payload;
      state.loading = false;
    },
    fetchRewardListAll(state, action) {
      state.rewardUserListAll = action.payload;
      state.loading = false;
    },
    fetchRewardDetail(state, action) {
      state.rewardDetail = action.payload;
      state.loading = false;
    },
    fetchRewardStart(state, action) {
      state.rewardItemsList = action.payload;
      state.loading = false;
    },
  },
});

export const rewardActions = rewardSlice.actions;

export default rewardSlice.reducer;
